import { get, post, put } from '@api/request';

export const createAssignment = async (
  { mobileService },
  authenticationToken,
  { payload },
) => {
  const url = `${mobileService}/mobile/assignments`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchAssignment = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateAssignment = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID, payload },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const setAssignmentAsCompleted = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}/complete`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const reopenAssignment = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}/reopen`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const fetchAssignmentCriteria = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}/assignmentcriteria`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const previewAssignmentCodeCounts = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID, payload },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}/massprioritypreview`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const validateAssignmentCriteria = async (
  { mobileService },
  authenticationToken,
  { payload },
) => {
  const url = `${mobileService}/mobile/assignment/assignmentcriteriavalidation`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateAssignmentCriteria = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID, payload },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}/assignmentcriteria`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchAssignmentQuery = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}/assignmentquery`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateAssignmentQuery = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID, payload },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}/assignmentquery`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const validateAssignmentQuery = async (
  { mobileService },
  authenticationToken,
  { payload },
) => {
  const url = `${mobileService}/mobile/assignment/validatequery`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const insertAssignmentProperty = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID, payload },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}/property`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchAssignmentProperties = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}/propertylist`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const captureAssignmentProperty = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}/captureproperty`;
  const { body } = await post(authenticationToken, url);
  return body;
};

export const setAssignmentPropertyPriority = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentPropertyID, payload },
) => {
  const url = `${mobileService}/mobile/assignmentproperty/${mobileAssignmentPropertyID}/setpriority`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const clearAssignmentPropertyPriority = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentPropertyID, payload },
) => {
  const url = `${mobileService}/mobile/assignmentproperty/${mobileAssignmentPropertyID}/clearpriority`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const setAssignmentAllPriority = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}/prioritizeall`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const clearAssignmentAllPriority = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}/clearpriorities`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const fetchAssignmentPriorities = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}/prioritypropertylist`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createAssignmentChangeset = async (
  { mobileService },
  authenticationToken,
  { payload },
) => {
  const url = `${mobileService}/mobile/validation/changesets`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchAssignmentChangesets = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}/changesets`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchAssignmentChangesetProperties = async (
  { mobileService },
  authenticationToken,
  { changesetID, page = 1, pageSize = 1000 },
) => {
  const url = `${mobileService}/mobile/validation/changeset/${changesetID}/properties?page=${page}&limit=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateAssignmentChangesetProperty = async (
  { mobileService },
  authenticationToken,
  { changesetID, changesetPropertyID, payload },
) => {
  const url = `${mobileService}/mobile/validation/changeset/${changesetID}/property/${changesetPropertyID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const submitAssignmentChangeset = async (
  { mobileService },
  authenticationToken,
  { changesetID },
) => {
  const url = `${mobileService}/mobile/validation/changeset/${changesetID}/submit`;
  const { body } = await post(authenticationToken, url);
  return body;
};

export const massUpdateAssignmentChangesetProperty = async (
  { mobileService },
  authenticationToken,
  { changesetID, payload },
) => {
  const url = `${mobileService}/mobile/validation/changeset/${changesetID}/massupdate`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const massCaptureAssignmentPriorities = async (
  { mobileService },
  authenticationToken,
  { mobileAssignmentID, payload },
) => {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}/masspriority`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const massProcessPendingChanges = async (
  { mobileService },
  authenticationToken,
  { payload },
) => {
  const url = `${mobileService}/mobile/validation/changesetgroups`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchChangesetGroupProperties = async (
  { mobileService },
  authenticationToken,
  { changesetGroupID },
) => {
  const url = `${mobileService}/mobile/validation/changesetgroup/${changesetGroupID}/properties`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const submitChangesetGroup = async (
  { mobileService },
  authenticationToken,
  { changesetGroupID },
) => {
  const url = `${mobileService}/mobile/validation/changesetgroup/${changesetGroupID}/submit`;
  const { body } = await post(authenticationToken, url);
  return body;
};

export const fetchDefaultPriorityCriteria = async (
  { mobileService },
  authenticationToken,
) => {
  const url = `${mobileService}/mobile/management/defaultprioritycriteria`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateDefaultPriorityCriteria = async (
  { mobileService },
  authenticationToken,
  { payload },
) => {
  const url = `${mobileService}/mobile/management/defaultprioritycriteria`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const rejectAfterApprovalAssignmentChangesetProperty = async (
  { mobileService },
  authenticationToken,
  { changesetID, changesetPropertyID, payload },
) => {
  const url = `${mobileService}/mobile/validation/changeset/${changesetID}/property/${changesetPropertyID}/rejectafterapproval`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};
